/**
 * Import Bootstrap JS
 */
import * as bootstrap from 'bootstrap';

// ...or individually as
//import Alert from 'bootstrap/js/dist/alert'
// ...or, specify which plugins you need:
//import { Alert, Tooltip, Toast, Popover } from 'bootstrap';


/**
 * Example exports for testing via Jest
 */
module.exports = {
  exampleSum: function (a, b) { return a+b; },
  isJqueryLoaded: (typeof jQuery === 'function' || typeof $ === 'function'),
  isBootstrapLoaded: (typeof jQuery().modal === 'function'),
}


/**
 * Document Ready Functions
 */
jQuery(document).ready(function($) {
  /**
   * Enable Bootstrap tooltips
   */
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, {
    container: 'body'
  }));

  /**
   * Determine "opened" height of FW Slider slide description (fallback for unsupported calc-size in Firefox/Safari)
   */
  if (!CSS.supports('height', 'calc-size(auto, size)')){
    console.info('Browser support for css calc-size() not detected: FW Slider slide description height fallback enabled.');
    $('.fw_slider-slide').on('mouseenter', function(ev) {
      const blurContent       = $(ev.target).closest('.splide__slide').find('.fw_slider-slide-description')[0],
        blurContentHeight = blurContent.scrollHeight;

      $(ev.target).find('.fw_slider-slide-description').height(blurContentHeight);
    }).on('mouseleave', function(ev) {
      $(ev.target).find('.fw_slider-slide-description').height(0);
    });
  }

  /**
   * Social Media New Window Pop-Ups (e.g. Twitter)
   */
  $('a.social-share').on('click', function(e){
    e.preventDefault();
    var url = $(this).attr('href');
    window.open(url, '_blank', 'toolbar=yes, scrollbars=yes, resizable=no, top=200, left=200, width=570, height=400');
  });

  /**
   * Open External Links in a new tab automatically
   */
  $('#content').on('click', 'a',function(ev) {
    const thisHost = new RegExp('/' + window.location.host + '/'),
          isExternalLink = this.href && !thisHost.test(this.href) && !$(this).hasClass('social-share');

    if (isExternalLink){
      event.preventDefault();
      event.stopPropagation();
      window.open(this.href, '_blank');
    }
  });

  /**
   * Sticky header compact logo on scroll (header-ai)
   */
  const $stickyNav = $('#header');
  const scrollWatcher = document.querySelector('.scroll-watcher');

  const observer = new IntersectionObserver((entries) => {
    // If the sentinel is intersecting (above the viewport), unstick the nav
    $stickyNav.toggleClass('is-scrolled', !entries[0].isIntersecting);
  });

  observer.observe(scrollWatcher);

  /**
   * Mobile Menu Toggler
   */
  $('#mobile-menu-button').on('click',function(e){
    e.preventDefault();

    // Toggle the active class
    $('body').toggleClass('mobile-menu-active');
    $(this).toggleClass('is-active');

    // Aria toggles
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });

    // Text Toggler
    var text = $('#mobile-menu-button .hamburger-text').text();
    $('#mobile-menu-button .hamburger-text').text(text == 'Menu' ? 'Close' : 'Menu');
  });

  /**
   * Force GF required mark into <sup>
   */
  $('.gform_wrapper .gfield_required').each(function() {
    var content = $(this).html();
    // Check if it's not already wrapped
    if (!$(this).find('sup').length) {
      $(this).html('<sup class="grc-gfield_required">' + content + '</sup>');
    }
  });

  /**
   * Post Index dropdown selected style
   */
  $('.grc-category-dropdown select, .grc-post_tag-dropdown select').on('change', function() {
    if (parseInt($(this).val()) > 0) {
      $(this).parent('.grc-dropdown').addClass('grc-dropdown__selected');
    } else {
      $(this).parent('.grc-dropdown').removeClass('grc-dropdown__selected');
    }
  });
  $('.grc-orderby-dropdown select').on('change', function() {
    if ($(this).val().length && $(this).val() !== 'newest') {
      $(this).parent('.grc-dropdown').addClass('grc-dropdown__selected');
    } else {
      $(this).parent('.grc-dropdown').removeClass('grc-dropdown__selected');
    }
  });

});


/**
 * Window Resize Functions
 */
jQuery(window).on('resize', function($) {

});